<template>

  <ion-page id="welcome-page">
     <ion-content >
       <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
             :style="styleOneFrame">
      <div id="myplot"></div>

    </div>
    <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
             :style="styleSlider">
      <ion-item>
        <ion-label class="ion-text-center">
          <h2>{{ minDateDisplay }} to {{  pinFormatter(maxDateDisplay) }}</h2>
        </ion-label>
        <ion-range :pin="true" aria-label="Dual Knobs Range" :dual-knobs="true" 
              :min="minDate" :max="maxDate" :step="1000"   v-model="value"
              :pin-formatter="pinFormatter"
              @ionKnobMoveStart="onIonKnobMove"
              @ionKnobMoveEnd="onIonKnobMove"
        >
        </ion-range>
      </ion-item>
    </div>
    </ion-content>
   </ion-page>
  </template>
  
  <script setup>
  
  import { IonLabel, IonItem,IonInput,IonPage, IonContent, IonRange ,modalController } from '@ionic/vue';
  
  import * as Plot from "@observablehq/plot"

  import { useGetData , generateErrorAlertText } from '@/composables/getData.js'
  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  import { ref, watch, onMounted } from 'vue'
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  
  import { availableWidthHeight } from '@/composables/screenSize'
  const connectionStore = useConnectionStore()
    
  const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)
  
  var value = {lower: 1000, upper: 2000}
  const minNumber = ref(value.lower)
  const maxNumber = ref(value.upper)
  const minDate = ref(0)
  const maxDate = ref(0)
  const minFilterDate = ref(0)
  const maxFilterDate = ref(0)
  const minDateDisplay = ref("")
  const maxDateDisplay = ref("")

  var rawGames = []
  var filteredGames = []
  var plot = null
  var plotDOMElement = null

  // var plot = Plot.rectY(
  //       {length: 10000}, 
  //       Plot.binX({y: "count"}, {x: Math.random})
  //   ).plot();

  const styleOneFrame = ref({
     position : "absolute",
     "overflow-y" : "scroll",
     top : "0px",
     left : "100px",
     width: "100px",
     height : "100px"
   })
  
   const styleSlider = ref({
     position : "absolute",
     "overflow-y" : "scroll",
     top : "0px",
     left : "100px",
     width: "100px",
     height : "100px"
   })

   const source = ref("https://www.chessvis.com/")
  
  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  updateWidthHeights()
  
  //doStartupCheck(false)
  getUserGames()

  onMounted(() => {
     console.log("graph mounted")

  
   })

  watch(() => windowSizeStore.getWindowSize, () => {
      //console.log('*********** window size changes detected')
      windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] }
      //console.log("*** logoff new window size",windowSizeRef.value)
      menuTrigger.value++
      updateWidthHeights()
    })
    
  
  function updateWidthHeights() {
  
    const sliderHeight = 100

    const availableSpace = availableWidthHeight()
    var oneframePositionTop = 0
    const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const oneframeHeight = availableSpace.height - sliderHeight
    const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2
  
    var sliderPositionTop = oneframePositionTop + oneframeHeight
    const sliderPositionLeft = oneframePositionLeft
    const sliderWidth = oneframeWidth

    oneframePositionTop += availableSpace.topIndent
    sliderPositionTop += availableSpace.topIndent

    styleOneFrame.value.height = oneframeHeight + "px"
    styleOneFrame.value.width = oneframeWidth + "px"
    styleOneFrame.value.top = oneframePositionTop + "px"
    styleOneFrame.value.left = oneframePositionLeft + "px"

    styleSlider.value.height = sliderHeight + "px"
    styleSlider.value.width = sliderWidth + "px"
    styleSlider.value.top = sliderPositionTop + "px"
    styleSlider.value.left = sliderPositionLeft + "px"

  }
  
  function makeFilteredGames() {
    filteredGames = []
    for (var i=0; i < rawGames.length; i++) {
      if (rawGames[i].date >= value.lower && rawGames[i].date <= value.upper)
        filteredGames.push(rawGames[i])
    }
  }

  function makePlot() {

    minFilterDate.value = filteredGames[0].date
    maxFilterDate.value = filteredGames[0].date
    for (var i=0; i < filteredGames.length; i++) {
      if (filteredGames[i].date < minFilterDate.value)
        minFilterDate.value = filteredGames[i].date 
      if (filteredGames[i].date > maxFilterDate.value)
        maxFilterDate.value = filteredGames[i].date 
    }

    console.log("in makeplot",minFilterDate.value,maxFilterDate.value)
    plot = Plot.plot({
      style: "overflow: visible;",
      y: {grid: true},
      x: {type: "utc", domain: [minFilterDate.value, maxFilterDate.value], grid: true},
      marks: [
        Plot.dot(filteredGames, {x: "date", y: "rating", stroke: "source_speed"}),
        Plot.text(filteredGames, Plot.selectLast({x: "date", y: "rating", z: "source_speed", text: "source_speed", textAnchor: "start", dx: 3}))
      ]
    })

    if (plotDOMElement == null) {
      const div = document.querySelector("#myplot");
      plotDOMElement = div.appendChild(plot);
    }
    else {
      plotDOMElement.replaceWith(plot)
      plotDOMElement = plot
    }
  }

  function formatDate(date,separator) {
    const year = date.toLocaleString('default', {year: 'numeric'});
    const month = date.toLocaleString('default', {
      month: '2-digit',
    });
    const day = date.toLocaleString('default', {day: '2-digit'});

    return [year, month, day].join(separator);
  }

  function pinFormatter(value) {
    var date = new Date(value);
    const dateFormatted = formatDate(date,"-")
    return (dateFormatted)
  }

  function onIonKnobMove({ detail }) {
    console.log('ionKnobMove:', detail.value);
    //console.log("value is ",value)
    minDateDisplay.value = pinFormatter(value.lower)
    maxDateDisplay.value = pinFormatter(value.upper)

    makeFilteredGames()
    makePlot()
  }


  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };


  function processGamesJsonResponse(json) {
    console.log(" in get games for graph callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    rawGames = json['games']
    for (var i=0; i < rawGames.length; i++) {
      rawGames[i].rating = parseInt(rawGames[i].rating)
      rawGames[i].date *= 1000
      rawGames[i].source_speed = rawGames[i].source + "," + rawGames[i].speed
    }

    filteredGames = rawGames

    minFilterDate.value = filteredGames[0].date
    maxFilterDate.value = filteredGames[0].date
    for (var i=0; i < filteredGames.length; i++) {
      if (filteredGames[i].date < minFilterDate.value)
        minFilterDate.value = filteredGames[i].date 
      if (filteredGames[i].date > maxFilterDate.value)
        maxFilterDate.value = filteredGames[i].date 
    }
    minDate.value = minFilterDate.value
    maxDate.value = maxFilterDate.value
    value.lower = minDate.value
    value.upper = maxDate.value

    minDateDisplay.value = pinFormatter(value.lower)
    maxDateDisplay.value = pinFormatter(value.upper)

    makePlot()
    //plot = Plot.lineY(games, {x: "date", y: "rating"}).plot({y: {grid: true}})

    //       x: {domain: [new Date("2020-01-01"), new Date("2024-01-01")], grid: true},

  }

  function getUserGames(gameText) {

    var formData = { 
      p : "p",
    }
    useGetData("getweb_user_game_graph.php", formData, processGamesJsonResponse)
  }

  </script>
  
  <style scoped>
  
  .item{
    margin:10px auto;
  }
  
  </style>